module.exports = __webpack_public_path__ + "img/market.618b09e7.svg";